<ion-header>
  <ion-toolbar>
    <ion-title>
      @if(isEdit) { 
        {{ 'Update Team' | translate }} 
      } @else { 
        {{ 'Create New Team' | translate }} 
      }
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card *ngIf="isItaLoginPresented">
    <ion-card-content>
      <ion-item lines="none" *ngIf="form?.get('teamId')?.value">
        <ion-label class="ion-text-wrap"
          >Successfully logged in with ITA account. Your roster and schedule
          will be imported once the team is created.</ion-label
        >
        <ion-icon
          slot="start"
          name="checkmark-circle"
          color="success"
        ></ion-icon>
      </ion-item>

      <ion-item lines="none" *ngIf="!form?.get('teamId')?.value">
        <ion-label class="ion-text-wrap"
          >You failed to log in with your ITA account. You can create a team but
          your roster and schedule will not be imported to iOnCourt.</ion-label
        >
        <ion-icon slot="start" name="alert-circle" color="warning"></ion-icon>
      </ion-item>

      <ion-button
        *ngIf="!form?.get('teamId')?.value"
        (click)="showItaLoginPopover()"
        expand="block"
        fill="outline"
      >
        Log in with ITA account
      </ion-button>
    </ion-card-content>
  </ion-card>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ion-item>
      <div class="upload-image">
        <app-upload-image
          (imageSelected)="imageSelected($event)"
          [userImage]="team?.profile_image ?? ITAlogo"
        ></app-upload-image>
      </div>
    </ion-item>
    <ion-item *ngIf="!isTypeDisabled">
      <ion-select
        label="{{ 'Type' | translate }}"
        label-placement="stacked"
        value="other"
        interface="popover"
        formControlName="type"
      >
        <ion-select-option name="College" value="college"
          >College</ion-select-option
        >
        <ion-select-option value="high-school">High School</ion-select-option>
        <ion-select-option value="other">Other</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item *ngIf="form.get('type').value === 'college'">
      <ion-select
        label="{{ 'Division' | translate }}"
        label-placement="stacked"
        value="other"
        interface="popover"
        formControlName="subtype"
      >
        <ion-select-option value="d1">Division 1</ion-select-option>
        <ion-select-option value="d2">Division 2</ion-select-option>
        <ion-select-option value="d3">Division 3</ion-select-option>
        <ion-select-option value="juco">JUCO</ion-select-option>
        <ion-select-option value="naia">NAIA</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item *ngIf="form.get('type').value === 'high-school'">
      <ion-select
        label="{{ 'State' | translate }}"
        label-placement="floating"
        value="other"
        interface="popover"
        formControlName="subtype"
      >
        <ion-select-option
          *ngFor="let state of states"
          [value]="state.abbreviation"
          >{{ state.name }}</ion-select-option
        >
      </ion-select>
    </ion-item>

    <ion-item>
      <ion-input
        label-placement="floating"
        name="Team Name"
        required
        formControlName="name"
        type="text"
      >
        <div slot="label">
          {{ "Team Name" | translate }} <ion-text color="danger">*</ion-text>
        </div>
      </ion-input>
    </ion-item>

    <ion-item>
      <ion-input
        label-placement="floating"
        name="Abbreviation"
        required
        formControlName="abbreviation"
        type="text"
        maxlength="8"
        #abbreviation
      >
        <div slot="label">
          {{ "Abbreviation" | translate }} <ion-text color="danger">*</ion-text>
        </div>
      </ion-input>
    </ion-item>

    <ion-item button (click)="getTeamColor()">
      <ion-text>{{'Team Color' | translate}}</ion-text>
      <ion-avatar slot="end">
        <div
          class="team-avatar"
          [ngStyle]="{ backgroundColor: form.get('colors').value }"
        >
          {{ abbreviation.value }}
        </div>
      </ion-avatar>
    </ion-item>

    <ion-item>
      <ion-input
        label-placement="floating"
        name="Team Description"
        formControlName="description"
        type="text"
      >
        <div slot="label">
          {{ "Team Description" | translate }}
        </div>
      </ion-input>
    </ion-item>

  </form>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-button
      (click)="onSubmit()"
      class="ion-margin"
      expand="block"
      color="primary"
      type="submit"
    >
      <span [hidden]="!(!isEdit && !isSubmitting)">{{ 'Save' | translate }}</span>
      <span [hidden]="!(isEdit && !isSubmitting)">{{ 'Update' | translate }}</span>
      <ion-spinner [hidden]="!isSubmitting" name="crescent"></ion-spinner>
    </ion-button>
  </ion-toolbar>
</ion-footer>
